import { FC, HTMLAttributes } from 'react'

interface Props extends HTMLAttributes<HTMLSpanElement> {
  size?: 'xs' | 'sm' | 'base' | 'lg' | 'xl' | '2xl'
  color?: 'default' | 'accent' | 'profit' | 'loss' | 'gold' | 'muted'
  shadow?: boolean
}

export const PixelText: FC<Props> = ({
  children,
  size = 'base',
  color = 'default',
  shadow = false,
  className = '',
  ...props
}) => {
  const sizeClasses = {
    xs: 'text-pixel-xs',
    sm: 'text-pixel-sm',
    base: 'text-pixel-base',
    lg: 'text-pixel-lg',
    xl: 'text-pixel-xl',
    '2xl': 'text-pixel-2xl',
  }

  const colorClasses = {
    default: 'text-game-text',
    accent: 'text-game-accent',
    profit: 'text-game-profit',
    loss: 'text-game-loss',
    gold: 'text-game-gold',
    muted: 'text-game-muted',
  }

  return (
    <span
      className={`
        font-pixel
        ${sizeClasses[size]}
        ${colorClasses[color]}
        ${shadow ? 'text-shadow-dark' : ''}
        ${className}
      `}
      {...props}
    >
      {children}
    </span>
  )
}
